import AlertRequestQuery from "~/entities/AlertRequestQuery";
import ValidationModule from "~/entities/ValidationModule";

export default class ValidationPayment extends ValidationModule {
  public paymentAlerts = {
    selector: {
      failed: "AlertPaymentFailed",
      stripeBlocked: "AlertTechnicalIssue",
      confirmOrderFailed: "AlertConfirmOrderFailed",
      confirmPaymentFailed: "AlertConfirmPaymentFailed",
      ACHException: "ACHExpectations",
    },
    needle: ["Credit Card"],
  };
  public promoAndDiscountAlerts = {
    selector: {
      promoAndDiscount: "AlertPromoAndDiscountFail",
      minimumAmount: "AlertMinimumPromoAmount",
      promo: "AlertPromo",
    },
    needle: ["#promoCode#", "#minimumAmount#"],
  };
  public orderAlerts = {
    selector: {
      booking: "AlertPurchaseWarning",
      pickupTime: "AlertPickupTimePassed",
      blocked: "AlertAccountBlocked",
      valid: "ValidOrder",
    },
    needle: [""],
  };

  public constructor() {
    super("Payment");
    this.alertNames = [
      "ValidOrder", //<strong>Thank you</strong>, submitting your order now
      "AlertPurchaseWarning", //Unable to verify this booking:
      "AlertPaymentFailed", //Your Credit Card payment was not successful. Please check your payment information and try again.
      "AlertPickupTimePassed", //You selected a pickup when ordering. Unfortunately, by the time you finished your order the deadline to schedule a pickup for #ORIGINALPICKUPDATE# had past. We have scheduled you the first available pickup for #PICKUPDATE#. If that does not work, please contact Support to make any necessary changes. Thanks.
      "AlertAccountBlocked", //Your order cannot be completed-Your account is currently suspended or you are shipping to a suspended account - please contact Support for further information.
      //'PaymentIssueDomestic',//We received your order, but there was an error in processing your payment. You will be contacted within an hour during our business hours for correct payment information or you can call BikeFlights.com at 541-705-2453. Labels will be issued within 15 minutes after payment is completed assuming your shipment is scheduled within the next 10 days; otherwise, you will receive your labels once inside the 10-day advance period set by carriers. Thanks for shipping with BikeFlights.com.
      //'PaymentIssueInternational',//We received your international order, but there was an error in processing your payment. You will be contacted within an hour during our business hours for correct payment information and to review your shipment purpose and details or you can call BikeFlights.com at 541-705-2453. We may require additional information for customs. Once we obtain your payment and and any further necessary information, you will receive your shipping documents within three hours assuming your shipment is scheduled within the next 10 days; otherwise, you will receive your labels once inside the 10-day advance period set by carriers. Thanks for shipping with BikeFlights.com.
      "AlertTechnicalIssue", //Our payment processing partner is experiencing a technical issue. While we work to fix this as quickly as possible, we suggest you pay with a \"saved payment method\" from your BikeFlights.com account or your PayPal account. In the event neither option works for you, please try again tomorrow. We apologize for the inconvenience.
      "AlertPromoAndDiscountFail", //Sorry, you can't apply a promo code if you already have your account set up with a discount.
      "AlertPromo", //Sorry! The promo code you just entered is not a valid one and can not be applied.
      "AlertConfirmOrderFailed", //Sorry! Your payment might have gone through but we were unable to confirm your order. Please contact support immediately to get help.
      "AlertConfirmPaymentFailed", //Sorry! Your payment might have gone through but we were unable to confirm your order. Please contact support immediately to get help.
      "AlertMinimumPromoAmount", //Heads up! The code #promoCode# was not applied because your current order does not meet the minimum amount <b>($#minimumAmount#)</b> for this promo code.
    ];
    this.alertTypes = {
      payment: this.paymentAlerts,
      discount: this.promoAndDiscountAlerts,
      order: this.orderAlerts,
    };
  }

  public async Validate(scope: string = "") {
    //for later Validate needs some kind of flag to asks for a particular validation type, depth or scope. so that only that method is called
    this.resetValidations();
    if (
      this.component.autoBillable ||
      this.component.selectedPaymentMethod ||
      this.component.subtotalIsCovered
    ) {
      return true;
    }
    let errors = 0;
    if (!this.component.isStripeValid) {
      errors++;
    }
    //do stuff
    if (errors == 0) {
      this.validated = true;
      this.validationMade = true;
    } else {
      this.validated = false;
      this.validationMade = true;
    }
    return !errors;
  }
  public resetValidations() {
    this.validated = false;
    this.validationMade = false;
    this.validationErrors = [];
    this.component?.clearActiveNotices();
  }
  public requestAlert(data: any) {
    this.component?.requestAlert(this.getFilteredAlertKey(data, "asObject"));
  }
  public addNotice(data: any) {
    this.component?.addNotice(this.getFilteredAlertKey(data));
  }
  public removeNotice(data: any) {
    this.component?.removeNotice(this.getFilteredAlertKey(data));
  }
  protected getFilteredAlertKey(
    data: any,
    returnType: string = "asString"
  ): any {
    let keyGetter = new AlertRequestQuery();
    if (data.hasOwnProperty("type")) {
      switch (data.type) {
        case "payment":
          keyGetter.name =
            this.alertTypes[data.type].selector[data.event.selector];
          keyGetter.typeSelector = data.event.selector;
          if (data.event.type) {
            keyGetter.replacements = {
              [this.alertTypes[data.type].needle[0]]: data.event.type,
            };
          }
          break;
        case "discount":
          keyGetter.name =
            this.alertTypes[data.type].selector[data.event.selector];
          keyGetter.typeSelector = data.event.selector;
          if (data.event.replacements) {
            keyGetter.replacements = {
              [this.alertTypes[data.type].needle[0]]:
                data.event.replacements[0],
              [this.alertTypes[data.type].needle[1]]:
                data.event.replacements[1],
            };
          }
          break;
        case "order":
          keyGetter.name = this.alertTypes[data.type].selector[data.event];
          keyGetter.typeSelector = data.event;
          break;
      }
    } else {
      //fill
    }
    let filteredData = keyGetter.getKey(
      this.alertNames,
      this.alertTypes[data.type]
    );
    if (returnType == "asString") {
      return filteredData.name;
    } else {
      return filteredData;
    }
  }
}
